import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';

interface ImageMetadata {
  width: number;
  height: number;
  size: number;
}

interface VideoMetadata {
  width: number;
  height: number;
  size: number;
  duration: number;
}

interface AudioMetadata {
  size: number;
  duration: number;
}

interface UploadIdResponse {
  uploadId: string;
}

interface FetchUploadIdParams {
  url: string;
  format: string;
  mimeType: string;
  signal?: AbortSignal;
  metadata?: ImageMetadata | VideoMetadata | AudioMetadata;
}

export const getUploadId = async ({
  url,
  format,
  mimeType,
  signal,
  metadata,
}: FetchUploadIdParams): Promise<UploadIdResponse> => {
  const type = format === 'audio' ? 'Audio' : format === 'image' ? 'Image' : 'Video';

  const formData = {
    url,
    type,
    mimeType,
    ...(metadata ? { metadata } : {}),
  };
  
  if(format === 'video' && !mimeType){
    mimeType = "video/mp4";
  }
  const response = await axiosInstance.post('/api/uploads', formData, { signal });
  return { uploadId: response.data?.id };
};

export function useUploadId() {
  return useMutation(getUploadId, {
    onSuccess: (data) => data,
  });
}
